import { ForwardedRef } from "react";
import { twMerge } from "tailwind-merge";
import { PropsWithAs } from "../types";
import { forwardRefWithGeneric } from "../utils";

export interface CardBodyProps {}

const CardBody = <T extends React.ElementType = "div">(
  { as, ...props }: PropsWithAs<CardBodyProps, T>,
  ref: ForwardedRef<any>
) => {
  const { className, ...rest } = props;
  const Component = as ?? "div";
  return (
    <Component
      {...rest}
      ref={ref}
      className={twMerge("px-4 last:pb-4 first:pt-4", className)}
    />
  );
};

export default forwardRefWithGeneric(CardBody);
